import React, { Component } from "react";
import cx from "../../utils/cx";
import s from "./index.css";
export * from "./CloseBtn";

export const withModal = WrappedCmp =>
  class extends Component {
    state = {
      open: false
    };

    closeModal() {
      this.setState({ open: false });
    }

    openModal() {
      this.setState({ open: true });
    }

    toggleModal() {
      this.setState({ open: !this.state.open });
    }

    render() {
      return (
        <WrappedCmp
          open={this.state.open}
          openModal={this.openModal.bind(this)}
          closeModal={this.closeModal.bind(this)}
          toggleModal={this.toggleModal.bind(this)}
          {...this.props}
        />
      );
    }
  };

export default ({
  open,
  children,
  onClose = v => v,
  scale = true,
  fadeUp = true
}) => (
  <div
    className={cx({
      [s.modal]: true,
      [s.open]: !!open
    })}
  >
    <div className={s.modalOverlay} onClick={onClose} />
    <div
      className={cx({
        [s.modalContent]: true,
        [s.scale]: scale,
        [s.fadeUp]: fadeUp
      })}
    >
      {children}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Modal/index.js